import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import {
  SignUpFormDefaultValues,
  SignUpFormValues,
  TempTokens,
  TempTokensDefaultValues,
} from '@providers/SignUpFormProvider/model/types.ts';

export interface SignUpFormContextValues {
  currentStep: number;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  backStep: () => void;
  forwardStep: () => void;
  signUpFormState: SignUpFormValues;
  setSignUpFormState: Dispatch<SetStateAction<SignUpFormValues>>;
  tempTokens: TempTokens;
  setTempTokens: Dispatch<SetStateAction<TempTokens>>;
}

const SignUpFormContext = createContext<SignUpFormContextValues>({
  currentStep: 0,
  setCurrentStep: () => {},
  backStep: () => {},
  forwardStep: () => {},
  signUpFormState: SignUpFormDefaultValues,
  setSignUpFormState: () => {},
  tempTokens: TempTokensDefaultValues,
  setTempTokens: () => {},
});

export const useSignUpFormContext = () => useContext(SignUpFormContext);

export { SignUpFormContext };
